import { render, staticRenderFns } from "./recruitment.vue?vue&type=template&id=2234f08f&scoped=true&"
import script from "./recruitment.vue?vue&type=script&lang=js&"
export * from "./recruitment.vue?vue&type=script&lang=js&"
import style0 from "./recruitment.vue?vue&type=style&index=0&id=2234f08f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234f08f",
  null
  
)

export default component.exports